var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "reviews-details" } },
    _vm._l(_vm.deviceReviews, function (deviceReview, index) {
      return _c("div", { key: "review-" + index }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-4 col-md-3 col-lg-2 small fw-bold ellipsis" },
            [
              _vm._v(
                "\n                " +
                  _vm._s(deviceReview.name) +
                  "\n            "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-5 d-md-none small" },
            [
              deviceReview.verified
                ? [
                    _c("span", [_vm._v(_vm._s(_vm.verified))]),
                    _vm._v(" "),
                    _c("span", {
                      staticClass:
                        "icon icon-Orange-Trust-Badge text-primary trust-badge",
                      attrs: { "aria-hidden": "true" },
                    }),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-3 d-md-none small" }, [
            _vm._v(
              "\n                " +
                _vm._s(deviceReview.date) +
                "\n            "
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-12 col-md-9 col-lg-10 pb-1 pb-md-0" },
            [
              deviceReview.rating
                ? _c("ob1-rating", {
                    attrs: {
                      average: deviceReview.rating,
                      "rating-results-height": 1.25,
                      "with-score": true,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-3 col-lg-2 d-none d-md-block small py-0" },
            [
              deviceReview.verified
                ? [
                    _c("span", [_vm._v(_vm._s(_vm.verified))]),
                    _vm._v(" "),
                    _c("span", {
                      staticClass:
                        "icon icon-Orange-Trust-Badge text-primary trust-badge",
                      attrs: { "aria-hidden": "true" },
                    }),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-12 col-md-9 col-lg-10 fw-bold" }, [
            _vm._v(
              "\n                " +
                _vm._s(deviceReview.title) +
                "\n            "
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-3 col-lg-2 d-none d-md-block small" }, [
            _vm._v(
              "\n                " +
                _vm._s(deviceReview.date) +
                "\n            "
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "col-12 col-md-9 col-lg-10 text-mw" }, [
            _vm._v(
              "\n                " +
                _vm._s(deviceReview.description) +
                "\n            "
            ),
          ]),
        ]),
        _vm._v(" "),
        deviceReview.originallyPublished
          ? _c("p", {
              domProps: { innerHTML: _vm._s(deviceReview.originallyPublished) },
            })
          : _vm._e(),
        _vm._v(" "),
        index !== _vm.deviceReviews.length - 1
          ? _c(
              "div",
              { staticClass: "col-12 px-0" },
              [_c("ob1-separateur", { staticClass: "mb-1 mb-md-2" })],
              1
            )
          : _vm._e(),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }